import React, { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { DomainNotificationBuilderView } from '../../components/notification-builder/views/domain-notification-builder-view'
import { mobileRoutes } from '../utils/mobile-routes'
import './mobile-compose.scss'

interface MobileComposeProps {
    formMode: 'create' | 'edit'
}

export const MobileCompose: React.FC<MobileComposeProps> = ({ formMode }) => {
    const { domainId } = useParams<{ domainId: string }>()
    const getParentRoute = useCallback(
        (isDraft: boolean) => (isDraft ? mobileRoutes.dashboardDrafts(domainId) : mobileRoutes.dashboard(domainId)),
        [domainId],
    )

    return (
        <div className="mobile-compose">
            <DomainNotificationBuilderView
                isMobile={true}
                formMode={formMode}
                hidePageHeader={true}
                hideEstimatedReach={true}
                hidePreview={true}
                hideVariantManager={true}
                hideTestConfig={true}
                hidePushlyAiToggle={true}
                showSendToDeviceInFooter={true}
                getParentRoute={getParentRoute}
            />
        </div>
    )
}
